import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { wizardStyles } from "./wow-wizard.css";

import "../progress-bar/wow-progress-bar";

@customElement("wow-wizard")
export class WowWizard extends LitElement {
  @property({ type: Number }) currentStep = 0;
  @property({ type: Number }) totalSteps = 0;

  static override styles = wizardStyles;

  private updateActiveStep() {
    const slots = this.shadowRoot?.querySelector("slot")?.assignedElements() || [];
    slots.forEach((element, index) => {
      if (index === this.currentStep) {
        element.classList.add("active");
      } else {
        element.classList.remove("active");
      }
    });
  }

  override updated(changedProperties: Map<string, unknown>) {
    if (changedProperties.has("currentStep")) {
      this.updateActiveStep();
    }
  }

  next() {
    if (this.currentStep < this.totalSteps - 1) {
      this.currentStep++;
      this.dispatchEvent(
        new CustomEvent("step-change", {
          detail: { step: this.currentStep },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  previous() {
    if (this.currentStep > 0) {
      this.currentStep--;
      this.dispatchEvent(
        new CustomEvent("step-change", {
          detail: { step: this.currentStep },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  override render() {
    return html`
      <div class="wizard-container">
        <wow-progress-bar .current=${this.currentStep + 1} .max=${this.totalSteps}></wow-progress-bar>
        <div class="step-content">
          <slot @slotchange=${this.updateActiveStep}></slot>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "wow-wizard": WowWizard;
  }
}
